import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { FreeTextSearchRepository } from '@modules/foresight/free-text-search/free-text-search.repository';
import { ProjectService } from '@frontend-site/shared/core';
import { from, Observable, switchMap } from 'rxjs';
import { FreeTextSearchState, Project } from '@frontend-site/shared/data';

@Injectable({
    providedIn: 'root'
})
export class ForesightDirectLinkToFtsGuard  {
    constructor(
        private router: Router,
        private freeTextSearchRepository: FreeTextSearchRepository,
        private projectService: ProjectService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, routerState: RouterStateSnapshot): Observable<boolean> {
        const queryParams: RequiredParams = route.queryParams;
        const state: FreeTextSearchState = { searchedText: queryParams.term, selectedRowsNodesIds: null };
        this.freeTextSearchRepository.updateFreeTextSearchState(state);
        let urlValue: Observable<boolean>;
        if (queryParams.projectId != null) {
            urlValue = this.getUrl(queryParams.projectId);
        } else {
            urlValue = this.projectService.getActiveProjects().pipe(
                switchMap((projects: Project[]) => {
                    return this.getUrl(projects[0]?.projectId.toString());
                })
            );
        }
        return urlValue;
    }

    private getUrl(projectId: string): Observable<boolean> {
        return from(this.router.navigateByUrl(`foresight/${projectId}/free-text-search`));
    }
}

interface RequiredParams {
    term?: string;
    projectId?: string;
}
